// extracted by mini-css-extract-plugin
export default {"container":"container-fQ4ga","title":"title-OKsvr","message":"message-kM7w9"};